import React from 'react';
import * as yup from 'yup';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	onSubmit: (
		values: ElectronicVaccinationCancellationConfirmationValues,
	) => void;
}

export interface ElectronicVaccinationCancellationConfirmationValues {
	reason: string;
}

const ElectronicVaccinationCancellationConfirmation: React.FC<Props> = ({
	onSubmit,
}) => {
	const { t } = useTranslation();

	const validationSchema = yup.object({
		reason: yup
			.string()
			.required(
				t(
					'nczi.electronicVaccinationCancellationConfirmation.reasonValidationMessage',
				),
			),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = (values: any) => {
		onSubmit(values as ElectronicVaccinationCancellationConfirmationValues);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<InputField
					name='reason'
					label='nczi.electronicVaccinationCancellationConfirmation.reason'
					isRequired
				/>
			</InputWrapper>
			<SubmitButton onSubmit={handleSubmit} />
		</FormWrapper>
	);
};

export default ElectronicVaccinationCancellationConfirmation;
